import React from "react";
import "./AssetTile.css";
import { Icon, IconGlyph } from "../../lib/Icon";
import { useDetermineImageClass } from "../../util";

export interface IAssetTileProps {
  item: IAsset;
}

export const AssetTile = ({ item }: IAssetTileProps): JSX.Element => {
  const imageClass = useDetermineImageClass(item);
  const { type } = item.media;

  return (
    <div className="asset__tile-container">
      <div className="asset__tile">
        <div className="asset__content">
          <img
            className={imageClass}
            src={item.media.medium}
            alt={item.altText ? item.altText : ""}
            loading="lazy"
          />
          {type === "Video" && (
            <Icon
              className="asset_content-play-button"
              glyph={IconGlyph.PLAY}
            />
          )}
        </div>
        <div className="asset__header-wrapper">
          <h4 className="asset__header-text" title={item.title}>
            {item.title}
          </h4>
        </div>
        {item.media?.download && (
          <div className="asset__footer" onClick={(e) => e.preventDefault()}>
            <a
              className="asset__footer-action web-gallery-download-icon-pendo-tracking"
              onClick={(e) => e.stopPropagation()}
              href={item.media.download}
              download
            >
              <Icon className="asset__footer-icon" glyph={IconGlyph.DOWNLOAD} />
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
